import { render, staticRenderFns } from "./UserDefinedItemSelectBehaviorEditor.vue?vue&type=template&id=8a59f588&scoped=true&"
import script from "./UserDefinedItemSelectBehaviorEditor.vue?vue&type=script&lang=ts&"
export * from "./UserDefinedItemSelectBehaviorEditor.vue?vue&type=script&lang=ts&"
import style0 from "./UserDefinedItemSelectBehaviorEditor.vue?vue&type=style&index=0&id=8a59f588&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a59f588",
  null
  
)

export default component.exports